import PropTypes from 'prop-types';
import React from 'react';
import { Button, Menu } from '@opendate-app/setlist';
import { ChevronDown, Download01 } from '@untitled-ui/icons-react';

import { serializeOrdersQuery } from '../constants/orderColumnsConfig';

const ExportCSV = ({
  csvDataSource,
  csvQuery,
  team,
  confirm
}) => {
  const download = (extraParams) => {
    window.location.href = `${csvDataSource}?${serializeOrdersQuery({ ...csvQuery, ...extraParams })}`;
  };

  const goTo = (path) => {
    window.location.href = `/teams/${team.id}/confirms/${confirm.id}/${path}`;
  };

  return (
    <Menu placement="bottom-end"
          trigger={<Button variant="secondary" size="sm" trailingIcon={ChevronDown}>Downloads</Button>}
          items={[
            { label: 'Export Orders CSV', icon: Download01, onClick: () => download({ csv_target: 'orders' }) },
            { label: 'Orders + Donations CSV', icon: Download01, onClick: () => download({ csv_target: 'order_donations' }) },
            {
              label: 'Manifested Tickets CSV',
              icon: Download01,
              onClick: () => download({ csv_target: 'tickets', ticket_filters: ['is_admission', 'manifested'], filename_suffix: 'manifested-only' })
            },
            {
              label: 'Cash Orders Report',
              icon: Download01,
              onClick: () => download({ csv_target: 'orders', filename_suffix: 'cash-only', dtq: { cash_true: true } })
            },
            {
              label: 'Premium Buyers',
              icon: Download01,
              onClick: () => download({ csv_target: 'tickets', ticket_filters: ['is_add_on'], filename_suffix: 'add-ons-only' })
            },
            { label: 'Ticket Audit', icon: Download01, onClick: () => goTo('ticket_audit_csv') },
            { label: 'Add-On Audit', icon: Download01, onClick: () => goTo('add_on_audit_csv') }
          ]} />
  );
};

ExportCSV.propTypes = {
  csvDataSource: PropTypes.string.isRequired,
  csvQuery: PropTypes.object.isRequired,
  team: PropTypes.object.isRequired,
  confirm: PropTypes.object.isRequired
};

export default ExportCSV;
